// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xq84","badges":"styles_badges__2fwPq"};